import PageTemplate from "./PageTemplate";
import Login from "./authorization/Login";
import AuthAndVideoCall from "./authandvideocall/AuthAndVideoCall";
import AllAuthAndVideoCall from "./authandvideocall/AllAuthAndVideoCall";
import AuthAndVideoCallApprove from "./authandvideocall/AuthAndVideoCallApprove";
import LeadPartyList from "./authandvideocall/LeadPartyList";
import CreateNewIdentity from "./createnewidentity/CreateNewIdentity";
import VideoConversation from "./videoconversation/VideoConversation";
import ShowApproval from "./approval/ShowApproval";
import MeetingVideoViewer from "./meetingvideoviewer/MeetingVideoViewer";
import MeetingPdfViewer from "./meetingpdfviewer/MeetingPdfViewer";
import HistoryReport from "./report/HistoryReport";
import AuthorizationPanel from "./authorization/AuthorizationPanel";
import FrequentlyAskedQuestions from "./faq/FrequentlyAskedQuestions";
import ActiveProcessReport from "./report/ActiveProcessReport";

const Pages = {
  PageTemplate,
  Login,
  LeadPartyList,
  AuthAndVideoCall,
  AllAuthAndVideoCall,
  AuthAndVideoCallApprove,
  CreateNewIdentity,
  VideoConversation,
  ShowApproval,
  MeetingVideoViewer,
  MeetingPdfViewer,
  HistoryReport,
  AuthorizationPanel,
  FrequentlyAskedQuestions,
  ActiveProcessReport
};

export default Pages;



// WEBPACK FOOTER //
// ./src/pages/index.js